/**
 * 運用管理　画面名記録用ファイル
 */
// tslint:disable-next-line:no-namespace
export namespace KnariScreenName {
  /** 運用管理トップ */
  export const KANRI_TOP: string = 'kanri-top';
  /** 組織管理メニュー */
  export const ORGANIZATION_MENU: string = 'organizationMenu';
  /** 組織登録 */
  export const ORGANIZATION_INFO: string = 'organizationInfo';
  /** 組織一覧 */
  export const ORGANIZATION_SEARCH: string = 'organizationSearch';
  /** ユーザ管理メニュー */
  export const USER_MENU: string = 'userMenu';
  /** ユーザ登録 */
  export const USER_INFO: string = 'userInfo';
  /** ユーザ一覧 */
  export const USER_SEARCH: string = 'userSearch';
  /** コードメンテナンスメニュー */
  export const MASTERCODE_MENU: string = 'masterCodeMenu';
  /** コード表登録 */
  export const MASTERCODE_TABLE_INFO: string = 'masterCodeTableInfo';
  /** コード表一覧 */
  export const MASTERCODE_TABLE_SEARCH: string = 'masterCodeTableSearch';
}
